import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/social-facebook.svg';
import { Icon } from '../Icon/Icon';
export const SocialFacebookIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
